import { connect } from 'react-redux';
import OptionSummary from './OptionSummary';

const mapStateToProps = ({ estimateBuilder }, ownProps) => {
  const { uiState, entities } = estimateBuilder;
  const { itemProduct } = entities.items.byId[ownProps.itemId];
  const {
    attributes, choices, brand, isValid, isStockProduct,
  } = itemProduct;
  const { isLockedOrOrdered } = entities.estimates.byId[uiState.selectedEstimate];
  const { isMandi } = entities.estimates.byId[uiState.selectedEstimate].attributes || false;
  const expandedOptions = choices.filter(choice =>
    !attributes
      .find(attribute => attribute.name.toLowerCase() === choice.optionName.toLowerCase()));
  const isOpen = uiState.expandedItems.indexOf(ownProps.itemId) !== -1;

  const hasWidthAndHeight =
    (attributes.findIndex(attribute => attribute.name === 'Width') >= 0 && attributes.findIndex(attribute => attribute.name === 'Height') >= 0);

  return {
    attributes,
    expandedOptions,
    brand,
    isOpen,
    hasWidthAndHeight,
    isValid,
    isLockedOrOrdered,
    isMandi,
    isStockProduct,
  };
};

export default connect(mapStateToProps)(OptionSummary);
